import { Checkbox, FormControlLabel } from "@mui/material";
import { FormFieldController } from "@src/appV2/PlacementCandidates/components/FormFieldController";
import { type Control } from "react-hook-form";

import { type RequirementMappingFormValues } from "../types";

interface IsOrientationRequirementFieldProps {
  control: Control<RequirementMappingFormValues>;
}

export function IsOrientationRequirementField(props: IsOrientationRequirementFieldProps) {
  const { control } = props;

  return (
    <FormFieldController
      name="isOrientationRequirement"
      control={control}
      label=""
      sx={{ mb: 2 }}
      render={(field) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={field.value}
              onChange={(event) => {
                field.onChange(event.target.checked);
              }}
              onBlur={field.onBlur}
            />
          }
          label="Orientation Requirement"
        />
      )}
    />
  );
}
